import React, { Component } from "react";
import './ConversationStyleSheet.css';
import HWLog from "../HWLibrary/HWLog";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

class ConversationHeader extends Component {

    constructor(props) {
        super(props);
        this.state = { isMenuOpen: false };
        this.menuContainerRef = React.createRef();
    }

    render() {
        let placeholderPic = "https://hummingwave-image-util.s3.amazonaws.com/agent-3x.png";
        let agentProfilePic = (this.props.activeConversation && this.props.activeConversation.agentInfo && this.props.activeConversation.agentInfo.userProfilePic) || placeholderPic;
        let isActiveConversation = this.props.isActiveConversation();
        let canDownloadTranscript = (this.props.config && this.props.config.configDetails && this.props.config.configDetails.sendChatTranscript) || false;

        let isSendChatTranscriptVisible  = canDownloadTranscript ? true : false;
        let isManualSessionActionEnabled = (this.props.config && this.props.config.configDetails && this.props.config.configDetails.allowManualSessionEnd === true);
        const isAnyMenuActionsEnabled      = isSendChatTranscriptVisible || isManualSessionActionEnabled;
        return (
            <div className="s360-conversation-header-container" style={this.containerStyle()}>
                <div className="s360-conversation-header-back-button">
                    {this.headerBackImage()}
                </div>
                <div className="s360-conversation-header-details-container">
                    <div className="s360-conversation-header-details-image" style={this.userImageStyle()} >
                        <img style={{ background: "white", width: "100%", height: "100%", borderRadius: "20px", overflow: "hidden" }} src={agentProfilePic} alt="" />
                        <div className="s360-conversation-header-agent-ping-status-container"><div className="s360-conversation-header-agent-ping-status" style={{ display: (this.props.agentPingStatus) ? "block" : "none", backgroundColor: (this.props.agentPingStatus || "red").toLowerCase() }} ></div></div>
                    </div>
                    <div style={{ paddingLeft: "10px", flexGrow: 1 }}>
                        <div className="s360-conversation-header-details-title">{this.parseName()}</div>
                        <div className="s360-conversation-typing-indicator">{this.isTyping()}</div>
                    </div>
                </div>
                <div ref={this.menuContainerRef}  className="s360-conversation-header-menu-option">
                    {this.menuOptionImage(isAnyMenuActionsEnabled)}
                    {(isAnyMenuActionsEnabled) && (<Menu
                        key={"options-menu-" + this.state.isMenuOpen}
                        anchorEl={this.menuContainerRef.current}
                        open={(this.state.isMenuOpen === true)}
                        onClose={this.menuOptionClose}>
                        { canDownloadTranscript && <MenuItem onClick={this.onSendChatTranscriptClick} style={this.menuItemStyle()}>Send chat transcript</MenuItem> }
                        { isManualSessionActionEnabled && !isActiveConversation && <MenuItem style={this.menuItemStyle()} onClick={this.startNewConversation}> New Conversation</MenuItem> }
                        { isManualSessionActionEnabled && isActiveConversation && <MenuItem style={this.menuItemStyle()} onClick={this.closeConversation} >Close conversation</MenuItem>}
                    </Menu>)}
                </div>
            </div>
        )
    }

    menuItemStyle = () => {
        return {
            color:      this.props.config.designDetails.selectionButtonTextColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
        }
    }
    
    onSendChatTranscriptClick = () => {
        this.setState({isMenuOpen: false }, () => {  this.props.onSendChatTranscriptClick(); });
    }

    closeConversation = () => {
        this.setState({isMenuOpen: false}, () => {  this.props.closeConversation(); });
    }

    startNewConversation = () => {
        this.setState({isMenuOpen: false},() =>  { this.props.startNewConversation(); })
    }

    isTyping = () => {
        return (this.props && this.props.isTyping) ? "Typing..." : "";
    }

    parseName = () => {
        return (this.props && this.props.activeConversation && this.props.activeConversation.agentInfo && this.props.activeConversation.agentInfo.shortName)
            ? this.props.activeConversation.agentInfo.shortName
            : "Chat Bot";
    }

    userImageStyle = () => {
        let config = this.props.config;
        return {}
    }

    menuOptionImage = (visible) => {
        let color = this.props.config.designDetails.pageBackgroundColor;
        return (<svg visibility={visible ? "visible" : "hidden"} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            // width="150" height="150"
            viewBox="0 0 50 50"
            onClick={this.onMenuAction}
            style={{ fill: color }}><path d="M 8 20 C 4.6875 20 2 22.6875 2 26 C 2 29.3125 4.6875 32 8 32 C 11.3125 32 14 29.3125 14 26 C 14 22.6875 11.3125 20 8 20 Z M 25 20 C 21.6875 20 19 22.6875 19 26 C 19 29.3125 21.6875 32 25 32 C 28.3125 32 31 29.3125 31 26 C 31 22.6875 28.3125 20 25 20 Z M 42 20 C 38.6875 20 36 22.6875 36 26 C 36 29.3125 38.6875 32 42 32 C 45.3125 32 48 29.3125 48 26 C 48 22.6875 45.3125 20 42 20 Z"></path></svg>)
    }

    menuOptionClose = () => {
        this.setState({ isMenuOpen: false });
    }

    headerBackImage = () => {
        let color = this.props.config.designDetails.pageBackgroundColor;
        return (<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            // width="96" height="96"
            viewBox="0 0 24 24"
            onClick={this.onBackAction}
            style={{ fill: color }}>    <path d="M 10 5.3417969 C 9.744125 5.3417969 9.4879688 5.4412187 9.2929688 5.6367188 L 3.6367188 11.292969 C 3.2457187 11.683969 3.2457187 12.317031 3.6367188 12.707031 L 9.2929688 18.363281 C 9.6839688 18.754281 10.317031 18.754281 10.707031 18.363281 L 10.792969 18.277344 C 11.183969 17.886344 11.183969 17.253281 10.792969 16.863281 L 6.9296875 13 L 20 13 C 20.552 13 21 12.552 21 12 C 21 11.448 20.552 11 20 11 L 6.9296875 11 L 10.792969 7.1367188 C 11.183969 6.7457187 11.183969 6.1126563 10.792969 5.7226562 L 10.707031 5.6367188 C 10.511531 5.4412187 10.255875 5.3417969 10 5.3417969 z"></path></svg>)
    }

    onMenuAction = (event) => {
        let anchorEl = event.currentTarget
        this.setState({ anchorEl: event.currentTarget, isMenuOpen: true })
    }

    onBackAction = () => {
        this.props.actions.showLandingScreen();
    }

    containerStyle = () => {
        let config = this.props.config;
        return {
            background: config.designDetails.headerBackgroundImage !== undefined && config.designDetails.headerBackgroundImage !== ""?("url("+config.designDetails.headerBackgroundImage+")"):config.designDetails.headerColor,
            color: config.designDetails.headerFontColor,
            fontFamily: config.designDetails.headerFont,
            fontSize: config.designDetails.headerFontSize
        }
    }
}

export default ConversationHeader;